import { useEffect, useLayoutEffect } from "react";
import isServer from "../../utils/isServer";
export default function useIsomorphicLayoutEffect() {
  return isServer() ? useEffect : useLayoutEffect;
}